import { Box, Button, CircularProgress, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import DialogComponent from "../../../common/components/functional/dialogs/DialogComponent";

type Props = {
  open: boolean;
  title: string;
  name: string;
  description: string;
  submitLabel: string;
  submitting: boolean;
  onClose: () => void;
  onNameChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onSubmit: () => void | Promise<void>;
};

const TesSalaryTableSeriesDialog = ({
  open,
  title,
  name,
  description,
  submitLabel,
  submitting,
  onClose,
  onNameChange,
  onDescriptionChange,
  onSubmit,
}: Props) => {
  const { t } = useTranslation();

  return (
    <DialogComponent autoWidth open={open} onClose={onClose}>
      <Box sx={{ p: 3, minWidth: 420 }}>
        <Typography variant="h6" fontWeight={700} marginBottom={2}>
          {title}
        </Typography>
        <Box display="flex" flexDirection="column" gap={2}>
          <TextField
            label={t("name")}
            value={name}
            onChange={(event) => onNameChange(event.target.value)}
            size="small"
            fullWidth
          />
          <TextField
            label={t("description")}
            value={description}
            onChange={(event) => onDescriptionChange(event.target.value)}
            size="small"
            fullWidth
          />
        </Box>
        <Box display="flex" justifyContent="flex-end" gap={1} marginTop={3}>
          <Button variant="outlined" onClick={onClose}>
            {t("common:cancel")}
          </Button>
          <Button
            variant="contained"
            disabled={submitting || !name.trim()}
            onClick={onSubmit}
          >
            {submitting && <CircularProgress size={16} sx={{ mr: 1 }} />}
            {submitLabel}
          </Button>
        </Box>
      </Box>
    </DialogComponent>
  );
};

export default TesSalaryTableSeriesDialog;
